var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_isarray@1.0.0@isarray/index.js
// module id = 5RIO
// module chunks = 0